export default __webpack_public_path__ + "static/Bedside-Monitoring-f59ca7c666025dc7044a7a3b2692fd13.png";